var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-bottom-margin"},[_c('h1',{staticClass:"header-style"},[_vm._v("\n    My Documents\n  ")]),_c('p',{staticClass:"subheader-style"},[_vm._v("\n    List of documents you have uploaded aganist this organization\n  ")]),_c('br'),_c('organization-documents')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }